(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccchrome-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-ccchrome-cart]');
  if(!root || root.dataset.bound) return;
  root.dataset.bound = '1';
  var MIN = parseInt(root.dataset.minPhotos,10) || 3;
  // Preserve original photos; keep every multipart request below the observed limit.
  var MAX_FILE = 10000000, MAX_TOTAL = 30000000, MAX_BATCH = 10000000;
  var CART_URL = (root.dataset.cartUrl || '/cart').replace(/\/$/, '');
  var ADD_URL = root.dataset.addUrl || '/cart/add';
  var rawItems = [], knownSizes = {}, items = [], draft = null, busy = false, loaded = false, retryAt = 0, objectURLs = [];
  var q = function(s){ return root.querySelector(s); };
  var qa = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var money = function(c){ return '$' + (c/100).toFixed(2); };
  var esc = function(t){ var d=document.createElement('div'); d.textContent=t==null?'':String(t); return d.innerHTML; };
  var id = function(){ return Date.now().toString(36)+'-'+Math.random().toString(36).slice(2)+'-'+Math.random().toString(36).slice(2); };
  var byteCount = function(photos){ return photos.reduce(function(n,f){return n+(typeof f==='string'?(knownSizes[f]||0):f.size);},0); };
  function validation(photos){
    if(photos.length<MIN) return 'Please add at least '+MIN+' photos.';
    if(photos.some(function(f){return typeof f!=='string' && f.size>MAX_FILE;})) return 'Each photo must be 10MB or smaller. Please select a smaller copy.';
    if(byteCount(photos)>MAX_TOTAL) return 'These photos exceed 30MB combined. Remove a photo or select smaller copies, keeping at least '+MIN+' photos.';
    return '';
  }
  q('[data-min-label]').textContent=MIN;
  function open(){root.classList.add('is-open');document.documentElement.style.overflow='hidden';}
  function close(){root.classList.remove('is-open');document.documentElement.style.overflow='';}
  function showError(msg){var e=q('[data-cart-error]');e.textContent=msg;e.hidden=false;}
  function clearError(){q('[data-cart-error]').hidden=true;}
  function setStep(s){
    qa('[data-pane]').forEach(function(p){p.hidden=p.getAttribute('data-pane')!==s;});
    qa('[data-foot]').forEach(function(p){p.hidden=p.getAttribute('data-foot')!==s;});
    q('[data-cart-title]').textContent=s==='piece'?'Upload photos':'Your cart';
  }
  function updateBadge(){
    var n=items.reduce(function(a,it){return a+it.quantity;},0);
    Array.prototype.slice.call(document.querySelectorAll('.ccchrome-hdr__cart')).forEach(function(link){
      var b=link.querySelector('.ccchrome-hdr__badge');
      if(n&&!b){b=document.createElement('span');b.className='ccchrome-hdr__badge';link.appendChild(b);}
      if(b){b.textContent=n;b.hidden=!n;b.style.display=n?'':'none';}
    });
  }
  function setBusy(value){
    busy=value;
    qa('button, textarea').forEach(function(b){b.disabled=value;});
    if(!value&&draft&&draft.locked){qa('[data-cart-thumbs] button, textarea').forEach(function(b){b.disabled=true;});}
    if(!value){q('[data-commit]').disabled=!draft||!!validation(draft.photos);q('[data-checkout]').disabled=!loaded||!items.length;}
    root.setAttribute('aria-busy',String(value));
  }
  async function request(url,options){
    var response;
    try{response=await fetch(url,Object.assign({credentials:'same-origin',cache:'no-store'},options||{}));}
    catch(e){throw new Error('Connection interrupted. Your selected photos are still here. Check your connection and try again.');}
    var data=null;
    try{data=await response.json();}catch(e){}
    if(!response.ok){
      if(response.status===413){if(draft){draft.uncertainUntil=0;}throw new Error('One photo upload was rejected as too large. Please use a smaller copy of that photo. Your other photos are still here.');}
      if(response.status===429){
        if(draft){draft.uncertainUntil=0;}
        var delay=Number(response.headers.get('Retry-After'));
        retryAt=Date.now()+Math.max(60,Number.isFinite(delay)?delay:60)*1000;
        throw new Error('Too many attempts. Please wait at least one minute before trying again. Your photos are still here.');
      }
      if(response.status>=400&&response.status<500&&draft){draft.uncertainUntil=0;}
      throw new Error(data&&(data.description||data.message)||'The cart could not be updated. Your photos are still here. Please try again shortly.');
    }
    if(!data) throw new Error('The cart response could not be confirmed. Please try again to check whether your item was saved.');
    return data;
  }
  function checkCooldown(){if(Date.now()<retryAt)throw new Error('Please wait '+Math.ceil((retryAt-Date.now())/1000)+' seconds before trying again.');}
  async function readCart(){
    var cart=await request(CART_URL+'.js');
    if(!Array.isArray(cart.items))throw new Error('Your cart could not be loaded. Please try again.');
    rawItems=cart.items;knownSizes={};
    rawItems.forEach(function(it){
      var props=it.properties||{},sizes={};try{sizes=JSON.parse(props._ccchrome_sizes||'{}');}catch(e){}
      Object.keys(props).forEach(function(k){if(/^Photo \d+$/.test(k))knownSizes[props[k]]=Number(sizes[k])||0;});
    });
    var groups={};items=[];
    rawItems.forEach(function(it){
      var props=it.properties||{},uid=props._ccchrome_piece;
      if(!uid||!props._ccchrome_batch){items.push(it);return;}
      if(!groups[uid])groups[uid]=[];groups[uid].push(it);
    });
    Object.keys(groups).forEach(function(uid){
      var group=groups[uid],complete=group.find(function(it){return it.properties._ccchrome_batch==='complete';});
      if(complete){items.push(complete);return;}
      var merged=Object.assign({},group[0],{properties:Object.assign({},group[0].properties),incomplete:true});
      group.forEach(function(it){Object.keys(it.properties).forEach(function(k){if(/^Photo \d+$/.test(k))merged.properties[k]=it.properties[k];});});
      items.push(merged);
    });
    loaded=true;updateBadge();return cart;
  }

  function photosOf(it){return Object.keys(it.properties||{}).filter(function(k){return /^Photo \d+$/.test(k);}).sort(function(a,b){return Number(a.slice(6))-Number(b.slice(6));}).map(function(k){return it.properties[k];}).filter(Boolean);}
  function renderList(){
    updateBadge();
    if(!items.length){setStep('empty');return;}
    q('[data-cart-lines]').innerHTML=items.map(function(it,i){
      return '<div class="ccchrome-cart__line"><div class="ccchrome-cart__line-ic">&#10003;</div><div class="ccchrome-cart__line-main"><div class="ccchrome-cart__line-name">'+esc(it.product_title||it.title)+'</div><div class="ccchrome-cart__line-meta">'+photosOf(it).length+' photos saved'+(it.incomplete?' · upload unfinished':'')+(it.quantity>1?' · quantity '+it.quantity:'')+' · <button type="button" class="ccchrome-cart__editlink" data-edit-index="'+i+'">Edit</button></div>'+(it.properties&&it.properties.Description?'<div class="ccchrome-cart__line-desc">'+esc(it.properties.Description)+'</div>':'')+'</div><div class="ccchrome-cart__line-right"><div class="ccchrome-cart__line-price">'+money(it.final_line_price)+'</div><button type="button" class="ccchrome-cart__rm" data-remove-index="'+i+'">Remove</button></div></div>';
    }).join('');
    var total=items.reduce(function(a,it){return a+it.final_line_price;},0);
    q('[data-cart-subtotal]').textContent=money(total);q('[data-cart-total]').textContent=money(total);
    var count=items.reduce(function(a,it){return a+it.quantity;},0);q('[data-cart-count]').textContent=count+(count===1?' piece':' pieces');setStep('list');if(items.some(function(it){return it.incomplete;}))showError('An upload was interrupted. Edit that item to add any missing photos and save, or remove it before checkout.');
  }
  function releaseURLs(){objectURLs.forEach(function(u){URL.revokeObjectURL(u);});objectURLs=[];}
  function renderThumbs(){
    releaseURLs();var wrap=q('[data-cart-thumbs]');wrap.innerHTML='';var ph=draft?draft.photos:[];
    ph.forEach(function(file,i){
      var cell=document.createElement('div');cell.className='ccchrome-cart__thumb';
      var url=typeof file==='string'?file:URL.createObjectURL(file);if(typeof file!=='string')objectURLs.push(url);
      // Only allow image URL schemes received from Shopify, never arbitrary CSS.
      if(/^(https?:|blob:|\/\/)/.test(url))cell.style.backgroundImage='url('+JSON.stringify(url)+')';
      var x=document.createElement('button');x.type='button';x.className='ccchrome-cart__thumb-x';x.textContent='×';x.setAttribute('aria-label','Remove photo '+(i+1));
      x.addEventListener('click',function(){if(busy||draft.locked)return;ph.splice(i,1);clearError();renderThumbs();});cell.appendChild(x);wrap.appendChild(cell);
    });
    var problem=validation(ph),total=byteCount(ph);
    q('[data-photo-count]').textContent=ph.length+' of '+MIN+' minimum · '+(total/1000000).toFixed(1)+'MB / 30MB per piece'+(!problem?' · ready':'');
    q('[data-photo-count]').classList.toggle('is-ready',!problem);q('[data-commit]').disabled=busy||!!problem;
    if(ph.length>=MIN&&problem)showError(problem);
  }
  function startDraft(d){
    draft=d;clearError();q('[data-piece-name]').textContent=d.name;q('[data-piece-price]').textContent=money(d.price);
    q('[data-piece-desc]').value=d.desc||'';q('[data-commit]').textContent=d.originalKey?'Save changes':'Add to cart →';renderThumbs();setStep('piece');open();
  }
  function addFiles(list){
    if(!draft||busy)return;if(draft.locked){showError('Please retry to confirm your previous upload before changing photos.');return;}clearError();var errors=[];
    Array.prototype.slice.call(list||[]).forEach(function(f){
      if(!/^image\//.test(f.type)&&! /\.(jpe?g|png|heic|heif|webp)$/i.test(f.name)){errors.push('Please choose image files.');return;}
      if(f.size>MAX_FILE){errors.push(f.name+' exceeds 10MB. Choose a smaller copy.');return;}
      draft.photos.push(f);
    });renderThumbs();if(errors.length)showError(errors.join(' '));
  }
  // Persist only the reconciliation marker, never photo data or customer text.
  var markerKey='ccchrome-cart-pending-v2';
  function remember(d){try{sessionStorage.setItem(markerKey,JSON.stringify({uid:d.uid,originalKey:d.originalKey||null,originalGroup:d.originalGroup||null}));}catch(e){}}
  function forget(){try{sessionStorage.removeItem(markerKey);}catch(e){}}
  function pending(){try{return JSON.parse(sessionStorage.getItem(markerKey)||'null');}catch(e){return null;}}
  function findSaved(uid){return items.find(function(it){return it.properties&&it.properties._ccchrome_piece===uid;});}
  async function removeKey(key){
    var line=rawItems.find(function(it){return it.key===key;});if(!line)return;
    await request(CART_URL+'/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
    await readCart();
  }
  function groupLines(uid){return rawItems.filter(function(it){return it.properties&&it.properties._ccchrome_piece===uid;});}
  async function removeGroup(uid){
    var keys=groupLines(uid).map(function(it){return it.key;});
    for(var k=0;k<keys.length;k++)await removeKey(keys[k]);
  }
  async function reconcile(marker){
    if(!marker)return null;
    var group=groupLines(marker.uid);if(!group.length)return null;
    var saved=group.find(function(it){return it.properties._ccchrome_batch==='complete'||!it.properties._ccchrome_batch;});
    var props=group[0].properties||{};
    var originalGroup=marker.originalGroup||props._ccchrome_original_group;
    var originalKey=marker.originalKey||props._ccchrome_original_key;
    if(!saved){
      var expected=Number(props._ccchrome_batches),present={};
      group.forEach(function(it){present[it.properties._ccchrome_batch]=true;});
      for(var n=0;n<expected;n++)if(!present[String(n)])return null;
      if(!expected)return null;
      var merged={},sizes={};
      group.forEach(function(it){
        Object.keys(it.properties).forEach(function(k){if(/^Photo \d+$/.test(k))merged[k]=it.properties[k];});
        try{Object.assign(sizes,JSON.parse(it.properties._ccchrome_sizes||'{}'));}catch(e){}
      });
      merged._ccchrome_piece=marker.uid;merged._ccchrome_batch='complete';merged._ccchrome_sizes=JSON.stringify(sizes);
      if(props.Description)merged.Description=props.Description;
      if(originalGroup)merged._ccchrome_original_group=originalGroup;
      if(originalKey)merged._ccchrome_original_key=originalKey;
      await request(CART_URL+'/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:group[0].key,quantity:group[0].quantity,properties:merged})});
      await readCart();saved=groupLines(marker.uid).find(function(it){return it.properties._ccchrome_batch==='complete';});
      if(!saved)throw new Error('Your photos are saved, but the item could not be confirmed. Please try again.');
    }
    // Delete staging lines only after the complete item contains every photo.
    var extra=groupLines(marker.uid).filter(function(it){return it.key!==saved.key;}).map(function(it){return it.key;});
    for(var i=0;i<extra.length;i++)await removeKey(extra[i]);
    if(originalGroup&&originalGroup!==marker.uid)await removeGroup(originalGroup);
    else if(originalKey&&originalKey!==saved.key)await removeKey(originalKey);
    forget();return saved;
  }
  async function reconcileAll(){
    // The server markers also recover a completed upload after navigating away.
    var uids=[];rawItems.forEach(function(it){var p=it.properties||{};if(p._ccchrome_piece&&p._ccchrome_batch&&uids.indexOf(p._ccchrome_piece)<0)uids.push(p._ccchrome_piece);});
    for(var i=0;i<uids.length;i++)await reconcile({uid:uids[i]});
  }
  function batchesFor(d){
    var batches=[[]],bytes=0;
    d.photos.forEach(function(f,index){
      var size=typeof f==='string'?0:f.size;
      if(bytes+size>MAX_BATCH&&batches[batches.length-1].length){batches.push([]);bytes=0;}
      batches[batches.length-1].push({file:f,index:index});bytes+=size;
    });return batches;
  }
  async function commitDraft(){
    if(busy||!draft)return;clearError();if(!draft.id){showError('This service is temporarily unavailable. Please contact us for help.');return;}
    var problem=validation(draft.photos);if(problem){showError(problem);return;}
    var d=draft;setBusy(true);q('[data-commit]').textContent='Saving photos…';
    try{
      checkCooldown();await readCart();
      var saved=await reconcile(d);
      if(!saved){
        if(d.uncertainUntil&&Date.now()<d.uncertainUntil)throw new Error('The previous upload is still being checked. Please wait one minute, then try again.');
        if(!d.batches)d.batches=batchesFor(d);
        remember(d);d.locked=true;
        for(var b=0;b<d.batches.length;b++){
          if(groupLines(d.uid).some(function(it){return it.properties._ccchrome_batch===String(b);}))continue;
          var fd=new FormData(),sizes={};fd.append('id',d.id);fd.append('quantity',d.quantity||1);
          fd.append('properties[_ccchrome_piece]',d.uid);fd.append('properties[_ccchrome_batch]',String(b));fd.append('properties[_ccchrome_batches]',String(d.batches.length));
          if(d.originalGroup)fd.append('properties[_ccchrome_original_group]',d.originalGroup);
          if(d.originalKey)fd.append('properties[_ccchrome_original_key]',d.originalKey);
          d.batches[b].forEach(function(entry){var key='Photo '+(entry.index+1);fd.append('properties['+key+']',entry.file);sizes[key]=typeof entry.file==='string'?(knownSizes[entry.file]||0):entry.file.size;});
          fd.append('properties[_ccchrome_sizes]',JSON.stringify(sizes));
          if(d.desc&&d.desc.trim())fd.append('properties[Description]',d.desc.trim());
          d.uncertainUntil=Date.now()+60000;q('[data-commit]').textContent='Saving photos '+(b+1)+' of '+d.batches.length+'…';
          await request(ADD_URL+'.js',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest'}});
          d.uncertainUntil=0;await readCart();
        }
        saved=await reconcile(d);
        if(!saved)throw new Error('Your upload could not yet be confirmed. Please wait one minute and try again.');
      }
      draft=null;releaseURLs();renderList();
    }catch(e){showError(e.message||'Your photos could not be saved. Please try again.');}
    finally{setBusy(false);q('[data-commit]').textContent=d.originalKey?'Save changes':'Add to cart →';}
  }
  async function loadList(){
    if(busy)return;clearError();open();setBusy(true);
    try{checkCooldown();await readCart();await reconcileAll();renderList();}
    catch(e){showError(e.message);}finally{setBusy(false);}
  }
  async function removeItem(index){
    if(busy)return;var it=items[index];if(!it)return;clearError();setBusy(true);
    try{checkCooldown();await readCart();if(it.properties&&it.properties._ccchrome_piece)await removeGroup(it.properties._ccchrome_piece);else await removeKey(it.key);renderList();}catch(e){showError(e.message);}finally{setBusy(false);}
  }
  async function checkout(){
    if(busy)return;clearError();setBusy(true);
    try{checkCooldown();await readCart();await reconcileAll();if(items.some(function(it){return it.incomplete;}))throw new Error('Please finish or remove the interrupted upload before checkout.');if(!items.length){renderList();return;}window.location=CART_URL.replace(/\/cart$/,'/checkout');}
    catch(e){showError(e.message);}finally{setBusy(false);}
  }
  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-ccchrome-add]');
    if(add){e.preventDefault();if(busy)return;if(draft){open();setStep('piece');showError('Finish or go back from your current piece before starting another.');return;}
      startDraft({id:add.getAttribute('data-variant-id')||'',name:add.getAttribute('data-name')||'Authentication',price:parseInt(add.getAttribute('data-price-cents'),10)||0,uid:id(),photos:[],desc:''});return;}
    if(e.target.closest('[data-ccchrome-cart-open]')){e.preventDefault();if(draft){open();setStep('piece');}else loadList();return;}
    if(e.target.closest('[data-ccchrome-cart-close]')){if(!busy)close();return;}
    if(busy)return;
    if(e.target.closest('[data-add-another]')){close();window.location.hash='#pricing';return;}
    if(e.target.closest('[data-commit]')){commitDraft();return;}
    if(e.target.closest('[data-piece-back]')){draft=null;releaseURLs();loadList();return;}
    if(e.target.closest('[data-checkout]')){checkout();return;}
    if(e.target.closest('[data-ccchrome-drop]')&&!e.target.matches('input[type="file"]')){q('[data-ccchrome-file]').click();return;}
    var ed=e.target.closest('[data-edit-index]');
    if(ed){var it=items[Number(ed.getAttribute('data-edit-index'))];if(it)startDraft({id:it.variant_id,name:it.product_title||it.title,price:it.final_price,quantity:it.quantity,uid:id(),originalKey:it.key,originalGroup:it.properties&&it.properties._ccchrome_piece,photos:photosOf(it),desc:it.properties&&it.properties.Description||''});return;}
    var rm=e.target.closest('[data-remove-index]');if(rm)removeItem(Number(rm.getAttribute('data-remove-index')));
  });
  q('[data-ccchrome-file]').addEventListener('change',function(e){addFiles(e.target.files);e.target.value='';});
  q('[data-piece-desc]').addEventListener('input',function(e){if(draft&&!busy&&!draft.locked)draft.desc=e.target.value;});
  var drop=q('[data-ccchrome-drop]');
  drop.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&!busy){e.preventDefault();q('[data-ccchrome-file]').click();}});
  drop.addEventListener('dragover',function(e){e.preventDefault();drop.classList.add('is-drag');});
  drop.addEventListener('dragleave',function(){drop.classList.remove('is-drag');});
  drop.addEventListener('drop',function(e){e.preventDefault();drop.classList.remove('is-drag');addFiles(e.dataTransfer.files);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!busy)close();});
  window.addEventListener('beforeunload',function(e){if(busy||(draft&&draft.photos.length)){e.preventDefault();e.returnValue='';}});
  setStep('empty');setBusy(true);
  readCart().then(function(){return reconcileAll();}).then(renderList).catch(function(){showError('Your saved cart could not be loaded. Open the cart to try again.');}).finally(function(){setBusy(false);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
